<template>
    <div class="ExecutiveDashboardLayout container-fluid">

        <div class="row">
            <div class="col-1">

            </div>
            <div class="col-11">
                <b-row v-show="PaneShown != 'TargetEditorPane'" class="dashboard-row">
                    <b-col md="4">
                        <div class="form-group">
                            <label>Period Starting:</label>
                            <flat-pickr v-model="Filters.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                        </div>
                    </b-col>
                    <b-col md="4">
                        <div class="form-group">
                            <label>Period Ending:</label>
                            <flat-pickr v-model="Filters.EndDate" class="form-control" required :config="DateConfig"></flat-pickr>
                        </div>
                    </b-col>
                </b-row>
                <div class="padding-adjust-for-overlay-scroll">
                    <div v-if="Filters.StartDate && Filters.EndDate" v-show="PaneShown == 'DashboardSummary'">
                        <DashboardSummary :start-date="Filters.StartDate" :end-date="Filters.EndDate" />
                    </div>
                    <!--FAMILIES-->
                    <div v-if="PaneShown == 'FosterInquiries'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/FosterInquiries"
                                               panel-title="Foster Family Inquiries"
                                               metric-name="Inquiries" />

                    </div>
                    <div v-if="PaneShown == 'HostInquiries'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/HostInquiries"
                                               panel-title="Host Family Inquiries"
                                               metric-name="Host Inquiries" />
                    </div>
                    <div v-if="PaneShown == 'HostActivations'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/HostActivations"
                                               panel-title="New Host Families"
                                               metric-name="New Host Families" />
                    </div>
                    <div v-if="PaneShown == 'FosterApplicantsInProgress'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/FosterApplicantsInProgress"
                                               panel-title="Foster Family Applicants in Progress"
                                               metric-name="Foster Applicants in Progress" />
                    </div>
                    <div v-if="PaneShown == 'FosterActivations'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/FosterActivations"
                                               panel-title="Newly Active Families"
                                               metric-name="Family Activations" />
                    </div>
                    <div v-if="PaneShown == 'FosterAvailableBeds'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/FosterAvailableBeds"
                                               panel-title="Foster Available Beds"
                                               metric-name="Available Beds" />
                    </div>
                    <!--CENSUS-->
                    <div v-if="PaneShown == 'OrganizationalCensus'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/ClientAverageDailyCensus"
                                               panel-title="Organizational Average Daily Census"
                                               metric-name="Average Census"
                                               core-program-id="" />
                    </div>
                    <div v-if="PaneShown == 'FosterCensus'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/ClientAverageDailyCensus"
                                               panel-title="Foster Average Daily Census"
                                               metric-name="Average Census"
                                               core-program-id="2E25AACC-64C2-4283-976D-DEA8B5052FA6" />
                    </div>
                    <div v-if="PaneShown == 'ResidentialCensus'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/ClientAverageDailyCensus"
                                               panel-title="Residential Average Daily Census"
                                               metric-name="Average Census"
                                               core-program-id="15A44C4E-9500-4706-B363-F0B7670B862C" />
                    </div>
                    <div v-if="PaneShown == 'TAYCensus'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/ClientAverageDailyCensus"
                                               panel-title="TAY Average Daily Census"
                                               metric-name="Average Census"
                                               core-program-id="FF8A6236-ACBA-4DFC-8A3C-610E41AECCB9" />
                    </div>
                    <div v-if="PaneShown == 'WrapCensus'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/ClientAverageDailyCensus"
                                               panel-title="Wraparound Average Daily Census"
                                               metric-name="Average Census"
                                               core-program-id="4B61365B-0C2F-4CE9-8BB0-D79584938614" />
                    </div>

                    <!--QA-->
                    <div v-if="PaneShown == 'FosterContactsWithClients'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/ContactsWithClients"
                                               panel-title="Foster Contacts with Clients"
                                               metric-name="Contacts with Clients"
                                               core-program-id="2E25AACC-64C2-4283-976D-DEA8B5052FA6" />
                    </div>

                    <!--FUND DEVELOPMENT-->
                    <div v-if="PaneShown == 'RaisersEdgeMeetingsDonors'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/RaisersEdgeMeetings"
                                               panel-title="Meetings with Donors"
                                               metric-name="Meetings with Donors"
                                               :church-only="false" />
                    </div>

                    <!--CHURCH ENGAGEMENT-->
                    <div v-if="PaneShown == 'RaisersEdgeMeetingsChurches'">
                        <MetricRegionalPlotter :start-date="Filters.StartDate"
                                               :end-date="Filters.EndDate"
                                               data-endpoint="Dashboards/Executive/RaisersEdgeMeetings"
                                               panel-title="Meetings with Churches"
                                               metric-name="Meetings with Churches"
                                               :church-only="true" />
                    </div>

                    <!--SETTINGS-->
                    <div v-if="PaneShown == 'TargetEditorPane'">
                        <TargetEditorPane secondary-specifier="ExecutiveCoreDashboard" />
                    </div>

                </div>
            </div>
        </div>
        

        <sidebar-menu :menu="menu" @item-click="OnNavItemClick" :collapsed="true"/>
    </div>
</template>

<script>
    //import components
    import { SidebarMenu } from 'vue-sidebar-menu'
    import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    //dashboards
    import DashboardSummary from './DashboardSummary.vue';
    import MetricRegionalPlotter from './MetricRegionalPlotter.vue';
    import TargetEditorPane from './TargetEditorPane.vue';

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faUsers } from '@fortawesome/free-solid-svg-icons';
    library.add(faUsers);
    import { faHome } from '@fortawesome/free-solid-svg-icons';
    library.add(faHome);


    export default {
        name: "ExecutiveDashboardLayout",

        data: function () {
            return {
                PaneShown: "DashboardSummary",
                Filters: {
                    StartDate: "",
                    EndDate: ""
                },
                menu: [
                    {
                        title: 'Summary',
                        icon: 'fa fa-star',
                        pane: 'DashboardSummary'
                    },
                    {
                        title: 'Families',
                        icon: 'fa fa-home',
                        child: [
                            {
                                header: true,
                                title: 'Foster',
                                hiddenOnCollapse: false
                            },
                            {
                                title: 'Foster Family Inquiries',
                                pane: 'FosterInquiries',
                            },
                            {
                                title: 'Foster Applicants in Process',
                                pane: 'FosterApplicantsInProgress'
                            },
                            {
                                title: 'New Foster Families',
                                pane: 'FosterActivations'
                            },
                            {
                                title: 'Foster Available Beds',
                                pane: 'FosterAvailableBeds',
                            },
                            {
                                header: true,
                                title: 'Host Homes',
                                hiddenOnCollapse: false
                            },
                            {
                                title: 'Host Family Inquiries',
                                pane: 'HostInquiries',
                            },
                            {
                                title: 'New Host Families',
                                pane: 'HostActivations',
                            }
                        ]
                    },
                    {
                        title: 'Census',
                        icon: 'fa fa-users',
                        child: [
                            {
                                title: 'ALL',
                                pane: 'OrganizationalCensus'
                            },
                            {
                                title: 'Foster',
                                pane: 'FosterCensus'
                            },
                            {
                                title: 'Residential',
                                pane: 'ResidentialCensus'
                            },
                            {
                                title: 'TAY',
                                pane: 'TAYCensus'
                            },
                            {
                                title: 'Wraparound',
                                pane: 'WrapCensus'
                            }
                        ]
                    },
                    {
                        title: 'QA',
                        icon: 'fa fa-exclamation-triangle',
                        child: [
                            {
                                title: 'Foster Contacts',
                                pane: 'FosterContactsWithClients'
                            }
                        ]
                    },
                    {
                        title: 'Fund Development',
                        icon: 'fa fa-dollar-sign',
                        child: [
                            {
                                title: 'Meetings with Doners',
                                pane: 'RaisersEdgeMeetingsDonors'
                            }
                        ]
                    },
                    {
                        title: 'Church Engagement',
                        icon: 'fa fa-church',
                        child: [
                            {
                                title: 'Meetings with Churches',
                                pane: 'RaisersEdgeMeetingsChurches'
                            }
                        ]
                    },
                    {
                        title: 'Settings',
                        icon: 'fas fa-gear',
                        child: [
                            {
                                title: 'Modify Targets',
                                pane: 'TargetEditorPane'
                            }
                        ]
                    }
                ],
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                console.log("changing pane from layout to" + paneName);
                this.PaneShown = paneName;
                this.$forceUpdate();
            },
            OnNavItemClick(event, item) {
                if (item.callback) {
                    this[item.callback]();
                }
                if (item.pane) {
                    this.ChangePaneShown(item.pane);
                }
            }
        },
        components: {
            SidebarMenu,
            flatPickr,

            //Dashboards
            DashboardSummary,
            MetricRegionalPlotter,
            TargetEditorPane
        },
        mounted() {
            //Set Filters to the last Monday-Sunday
            this.Filters.StartDate = moment().startOf('week').add((-6 + (-7*4)), "days").format("YYYY-MM-DD");
            this.Filters.EndDate = moment().startOf('week').format("YYYY-MM-DD");
        },
        computed: {
            
        }
    }
</script>

<style scoped>
    body {
        background-color: white !important;
    }
</style>